import React from 'react';
import { useDispatch } from 'react-redux';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

const Email = () => {
	const dispatch = useDispatch();

	const handleChangeEmail = (e) => {
		let { value, name } = e.target;
		let data = {
			name: 'email',
			type: 'text',
			key: value,
			value: value,
			identifier: name
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<div className="card">
			<div className="card-header" id="headingEmail">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#collapseEmail"
						aria-expanded="false"
						aria-controls="collapseEmail"
					>
						Email
					</button>
				</h5>
			</div>

			<div
				id="collapseEmail"
				className="collapse"
				aria-labelledby="headingEmail"
				data-parent="#accordion"
			>
				<div className="card-body">
					<div className="container range-input pt-2 px-0">
						<div className="row">
							<div className="col-md-12">
								<div className="form-group mb-0">
									<input
										type="text"
										autoComplete="off"
										id="email"
										onChange={(e) => handleChangeEmail(e)}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Email;
